import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import "./NavMenu.css";
import headerIcon from "../../assets/img/AUXO-Logo(coldchain).png";
import overviewIcon from "../../assets/img/overview.png";

import settingsIcon from "../../assets/img/settings.png";
import reportsIcon from "../../assets/img/reports.png";
import driversIcon from "../../assets/img/drivers.png";
import UserAuthentication from "../../ducks/UserAuthentication";
import Reports from "../../ducks/Reports";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { UncontrolledCollapse } from "reactstrap";
import ic_group from "../../assets/img/ic_group.png";
import observationIcon from "../../assets/img/Observation icon.png";
import Modal from 'react-bootstrap4-modal';

class NavMenu extends Component {
  constructor() {
    super();
    try {
      let groupData = JSON.parse(localStorage.getItem("groupInfo"));
      let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
      if (!groupData) {
        groupData = {
          depthLevel: 3,
        };
      }
      this.state = {
        groupDepthLevel: groupData.depthLevel,
        companyId: companyInfo.companyId,
        openReports: false,
        openSetting: false,
        openVisualization: false,
      };
    } catch (err) {}
    this.toggle = this.toggle.bind(this);
  }
 
  logoutUser = async () => {
    await this.props.logoutActions.logoutUser();
    this.props.history.push("/login");
  };

  toggle = () => {
    this.props.reportActions.toggleModal();
  };
  openReports() {
    this.setState({
      ...this.state,
      openReports: !this.state.openReports,
    });
  }
  openSetting() {
    this.setState({
      ...this.state,
      openSetting: !this.state.openSetting,
    });
  };

  openVisualization() {
    this.setState({
      ...this.state,
      openVisualization: !this.state.openVisualization,
    });
  };

  render() {
    return (
      <>
        <nav className="col-sm-3 col-md-2 d-none d-sm-block bg-faded sidebar">
          <NavLink className="sidebar-header" exact to="/">
            {
              <img
                src={headerIcon}
                alt="Auxo Fleet"
                className="p-2 header-icon-auxo"
              />
            }
            {/* {<img  src={headerIconBeta} alt="Auxo Fleet" className="p-2 header-icon-auxo"/>} */}
          </NavLink>
          <div className="nav-divider" />
          <ul className="nav nav-pills flex-column">
            
                <li className="nav-item">
                  <NavLink
                    className="nav-link "
                    activeclassname="active"
                    exact
                    to="/"
                  >
                    <span className="nav-item-box">
                      <img
                        className="nav-item-icon"
                        src={overviewIcon}
                        alt=""
                      />
                      <span className="nav-text">Dashboard</span>
                    </span>
                  </NavLink>
                </li>
          
          
            
                {/* <li className="nav-item">
                  <NavLink
                    className="nav-link "
                    activeClassName="active"
                    to="/devices/chiller-observation"
                  >
                    <span className="nav-item-box">
                      <img
                        className="nav-item-icon"
                        src={observationIcon}
                        alt=""
                      />
                      <span className="nav-text">
                       Temperature Logs
                      </span>
                    </span>
                  </NavLink>
                </li> */}

                <li className="nav-item">
                  <NavLink
                    className="nav-link "
                    activeClassName="active"
                    to="/devices/tempchiller-observation"
                  >
                    <span className="nav-item-box">
                      <img
                        className="nav-item-icon"
                        src={observationIcon}
                        alt=""
                      />
                      <span className="nav-text">
                       Temp Observations
                      </span>
                    </span>
                  </NavLink>
                </li>
           
              <li className="nav-item">
                <NavLink
                  className="nav-link "
                  activeclassname="active"
                  exact
                  to="/groups"
                >
                  <span className="nav-item-box">
                    <img className="nav-item-icon" src={ic_group} alt="" />
                    <span className="nav-text">Groups</span>
                  </span>
                </NavLink>
              </li>


                <li className="nav-item">
                  <a
                    className="nav-link "
                    activeclassname="active"
                    id="reportsToggle"
                    onClick={this.openReports.bind(this)}
                  >
                    <span className="nav-item-box">
                      <img className="nav-item-icon" src={reportsIcon} alt="" />
                      <span className="nav-text">
                        Reports  <i
                        className={
                          this.state && this.state.openReports
                            ? "fa-caret-down fa float-right mt-lg-3"
                            : "fa-caret-right fa float-right mt-lg-3"
                        }
                      />
                      </span>
                    </span>
                  </a>
                  <UncontrolledCollapse
                    toggler="#reportsToggle"
                    className="collapse-nav"
                  >
                    <ul className="nav nav-pills flex-column">
                      <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/reports"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Request Reports</span>
                          </span>
                        </NavLink>
                        {/* <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/distanceReport"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Distance Report</span>
                          </span>
                        </NavLink> */}
                        <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/download/reports"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">View Reports</span>
                          </span>
                        </NavLink>
                        {/* <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/temperatureReport"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Temperature Report</span>
                          </span>
                        </NavLink> */}
                        {/* <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/observationReport"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Observation Report</span>
                          </span>
                        </NavLink> */}
                      </li>
                    </ul>
                  </UncontrolledCollapse>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    activeclassname="active"
                    id="visualizationToggle"
                    onClick={this.openVisualization.bind(this)}
                  >
                    <span className="nav-item-box">
                      <img className="nav-item-icon" src={driversIcon} alt="" />
                      <span className="nav-text">
                        Visualization  <i
                        className={
                          this.state && this.state.openVisualization
                            ? "fa-caret-down fa float-right mt-lg-3"
                            : "fa-caret-right fa float-right mt-lg-3"
                        }
                      />
                      </span>
                    </span>
                  </a>
                  <UncontrolledCollapse
                    toggler="#visualizationToggle"
                    className="collapse-nav"
                  >
                    <ul className="nav nav-pills flex-column">
                      <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/visualization/violations"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Violations</span>
                          </span>
                        </NavLink>
                        <NavLink
                          className="nav-link "
                          activeClassName="active"
                          to="/visualization/summary"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Summary</span>
                          </span>
                        </NavLink>
                      </li>
                    </ul>
                  </UncontrolledCollapse>
                </li>
           
              <li className="nav-item">
                <a
                  className="nav-link "
                  activeclassname="active"
                  id="settingsToggle"
                  onClick={this.openSetting.bind(this)}
                >
                  <span className="nav-item-box">
                    <img className="nav-item-icon" src={settingsIcon} alt="" />
                    <span className="nav-text">
                      Settings
                      <i
                        className={
                          this.state && this.state.openSetting
                            ? "fa-caret-down fa float-right mt-lg-3"
                            : "fa-caret-right fa float-right mt-lg-3"
                        }
                      />
                    </span>
                  </span>
                </a>
                <UncontrolledCollapse
                  toggler="#settingsToggle"
                  className="collapse-nav"
                >
                  <ul className="nav nav-pills flex-column">

                    {this.state.companyId === "686f9bab6a94aa3a86c61f35" && (
                        <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          activeclassname="active"
                          to="/mondelezDeviceSettings"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Mondelez device settings</span>
                          </span>
                        </NavLink>
                      </li>
                    )}
                      <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          activeclassname="active"
                          to="/account"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Account</span>
                          </span>
                        </NavLink>
                      </li>
                    
                  
                      <li className="nav-item">
                        <NavLink
                          className="nav-link "
                          activeclassname="active"
                          to="/users"
                        >
                          <span className="nav-item-box">
                            <span className="nav-text">Users</span>
                          </span>
                        </NavLink>
                      </li>
                 
                   
                  </ul>
                </UncontrolledCollapse>
              </li>
          
          </ul>
        </nav>
        <Modal
          visible={this.props.modal}
          dialogClassName="delete-modal-dialog"
        >
          <div>
            <button
              type="button"
              className="close close-x"
              aria-label="Close"
              onClick={() => this.toggle()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-heading">
            <h5 className="car-and-device-assig">Report Request</h5>
          </div>
          <div className="modal-body">
            <h6>Your report is being generated. Please check log section.</h6>
          </div>
          <div className="modal-footer model-btn">
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.navigateToLogs()}
            >
              View Reports
            </button>{" "}
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.toggle()}
            >
              Cancel
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

NavMenu.propTypes = {};
NavMenu.defaultProps = {};
const mapStateToProps = (state) => ({
  permissions: state.permissions,
  modal: state.Reports.modal,
});

const mapDispatchToProps = (dispatch) => ({
  logoutActions: bindActionCreators(UserAuthentication.creators, dispatch),
  reportActions: bindActionCreators(Reports.creators, dispatch),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavMenu)
);
